export default __webpack_public_path__ + "static/media/14-CarstenJensen.bda2c7b9.png";